import { combineReducers } from '@reduxjs/toolkit';
import featuresReducers from './list';

const featuresReducer = combineReducers({
  list: featuresReducers
});

export default featuresReducer;

export type FeaturesReducer = ReturnType<typeof featuresReducer>
